import { render, staticRenderFns } from "./TimelineEmailCard.vue?vue&type=template&id=189b1df2"
import script from "./TimelineEmailCard.vue?vue&type=script&lang=js"
export * from "./TimelineEmailCard.vue?vue&type=script&lang=js"
import style0 from "./TimelineEmailCard.vue?vue&type=style&index=0&id=189b1df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports